﻿import { onEvent } from "./_dom";


function init(context, selector = "a[data-popup]") {
	onEvent(context, selector, "click", (event, a) => {
		event.preventDefault();
		window.open(a.href, a.target, a.dataset.popup, true);
	});
}

export { init };